import gsap from "gsap";

export function render() {
  const cursor = document.querySelector(".-js-cursor");
  document.addEventListener("pointermove", (e) => {
    gsap.set(cursor, {
      left: e.clientX,
      top: e.clientY,
    });
  });

  const elements = document.querySelectorAll("[data-color-cursor]");
  const arrow = cursor.querySelector(".c-cursor__arrow>path");
  const border = cursor.querySelector(".c-cursor__border");

  function hideCursor(color) {
    gsap.to(border, {
      ease: "Back.easeOut",
      scale: "0",
    });
    gsap.to(arrow, {
      fill: color,
    });
  }

  function showCursor() {
    gsap.to(border, {
      ease: "Back.easeOut",
      scale: "1",
    });
    gsap.to(arrow, {
      fill: "#FF62CF",
    });
  }

  gsap.utils.toArray(elements).forEach((el) => {
    const color = el.getAttribute("data-color-cursor");
    el.addEventListener("mouseenter", () => hideCursor(color));
    el.addEventListener("mouseleave", () => showCursor());
  });
}
